import axios from "axios";
import apiUrlOne from "../Config";

// Get all stores (admin)
export const getAllStoresAdmin = async (params = {}) => {
    const response = await axios.get(`${apiUrlOne}/store/getallstoreby-admin`, {
        params: params
    });
    return response.data;
};

// Get all stores (public)
export const getAllStoresPublic = async () => {
    const response = await axios.get(`${apiUrlOne}/store/getallstores`);
    return response.data;
};

// Get store by ID
export const getStoreById = async (id) => {
    if (!id) throw new Error("Store ID is required");
    const response = await axios.get(`${apiUrlOne}/store/get-store/${id}`);
    return response.data;
};

// Create store
export const createStore = async (formData) => {
    const response = await axios.post(`${apiUrlOne}/store/create-stores`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

// Update store
export const updateStore = async (id, formData) => {
    if (!id) throw new Error("Store ID is required");
    const response = await axios.put(`${apiUrlOne}/store/update-stores/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

// Delete store (soft delete)
export const deleteStore = async (id) => {
    if (!id) throw new Error("Store ID is required");
    const response = await axios.delete(`${apiUrlOne}/store/delete-stores/${id}`);
    return response.data;
};
